/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: none;
}

:host([show]) {
  display: block;
  position: absolute;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
  max-width: calc(400rem/14);
  min-width: -webkit-max-content;
  min-width: -moz-max-content;
  min-width: max-content;
  width: 100%;
  border: 1px solid var(--davinci-color-outline,#B4BEC5);
  max-height: calc(336rem/14);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 100;
  line-height: calc(22rem/14);
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}
:host([show]) .item {
  padding: calc(10rem/14);
  cursor: pointer;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
  white-space: nowrap;
}
:host([show]) .item em {
  font-style: normal;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  font-weight: 600;
}
:host([show]) .item:hover {
  background-color: #e5f1f8;
  background-color: var(--davinci-color-information-primary-light, #e5f1f8);
}
:host([show]) #activeitem {
  background-color: var(--davinci-color-information-primary-light,#e5f1f8) !important;
}

:host([opentop]) {
  border-top: none;
}`;
export { style };
//# sourceMappingURL=PopupList.style.js.map